import { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible';
import { cn } from 'utils/cn';

function Collapsible({ ...props }: CollapsiblePrimitive.Root.Props) {
    return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

function CollapsibleTrigger({ className, ...props }: CollapsiblePrimitive.Trigger.Props) {
    return (
        <CollapsiblePrimitive.Trigger
            data-slot="collapsible-trigger"
            className={cn('cursor-pointer', className)}
            {...props}
        />
    );
}

function CollapsibleContent({ ...props }: CollapsiblePrimitive.Panel.Props) {
    return <CollapsiblePrimitive.Panel data-slot="collapsible-content" {...props} />;
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
